// src/pages/Projects.jsx

import React from 'react';
import './Projects.css';
import { projects } from '../data/projects';
import ProjectCard from '../components/ProjectCard';
import GeometricDivider from '../components/GeometricDivider';
import useDocumentTitle from '../hooks/useDocumentTitle';

export default function Projects() {
  useDocumentTitle('Projects', 'A showcase of Arian Kazemi’s recent software projects, including AriChat, SteadySkull, and this portfolio.');

  return (
    <>
      <section className="hero">
        <div className="hero-content page-container">
          <h1>Projects</h1>
          <p className="tagline">A showcase of my recent work and demos.</p>
        </div>
      </section>

      <GeometricDivider />

      <section className="projects page-container">
        <div className="projects-grid">
          {projects.map((p, i) => (
            <ProjectCard key={p.slug} project={p} index={i} />
          ))}
        </div>
      </section>

      <GeometricDivider />
    </>
  );
}
